<template>
  <v-card flat :loading="loading" :disabled="loading">
    <v-list dense class="menu_dashboard pt-0">
      <v-list-item-group color="secondary">
        <v-list-item to="/">
          <v-list-item-action>
            <v-icon>mdi-keyboard-return</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Voltar</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mb-2"></v-divider>
        <div v-for="(menu, index) in menus" :key="index">
          <v-list-item
            :to="menu.no_action ? '' : { path: menu.path }"
            v-if="menu.type === 'single'"
            :disabled="menu.disabled"
            @click="menu.click_menu ? mudaMenu(menu.click_menu) : ''"
          >
            <v-list-item-icon>
              <v-icon>{{ menu.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ menu.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-group
            v-if="menu.type === 'group'"
            :group="menu.path"
            no-action
            :prepend-icon="menu.icon"
            :disabled="menu.disabled"
          >
            <template v-slot:activator>
              <v-list-item-title>{{ menu.name }}</v-list-item-title>
            </template>
            <div v-for="(child, index) in menu.children" :key="index">
              <v-list-item
                v-if="child.type === 'single'"
                :to="{ path: child.path }"
                :disabled="child.disabled"
              >
                <v-list-item-icon>
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ child.name }}</v-list-item-title>
              </v-list-item>
            </div>
          </v-list-group>
        </div>
      </v-list-item-group>
    </v-list>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "MenuDashboard",

  data() {
    return {
      loading: false,
      menus: null,
    };
  },

  computed: {
    ...mapGetters("Componentes", ["getAccess"]),
  },

  methods: {
    mudaMenu(menu) {
      this.$store.commit("UPDATE_MENUDINAMICO", menu);
    },
  },

  async mounted() {
    this.loading = true;

    this.menus = [
      {
        type: "single",
        name: this.$tc("global.usuario", 2),
        path: "/super-admin/usuarios",
        icon: "mdi-account-circle",
        disabled: false,
      },
      {
        type: "single",
        name: this.$tc("global.empresa", 2),
        path: "/super-admin/empresas",
        icon: "mdi-domain",
        disabled: false,
      },
      {
        type: "single",
        name: this.$tc("global.moeda", 2),
        path: "/super-admin/moedas",
        icon: "mdi-currency-usd",
        disabled: false,
      },
      {
        type: "single",
        name: "Formas de Pagamento",
        path: "/super-admin/formas-de-pagamento",
        icon: "mdi-cash-plus",
        disabled: false,
      },
      {
        type: "single",
        name: this.$tc("global.auditoria"),
        path: "/super-admin/audits",
        icon: "mdi-security",
        disabled: false,
      },
      {
        type: "single",
        name: this.$tc("global.permissao", 2),
        path: "/super-admin/permissoes",
        icon: "mdi-account-lock",
        disabled: false,
      },
    ];
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
.menu_dashboard ::v-deep .v-list-item {
  padding-top: 3px;
  padding-bottom: 3px;
  margin-bottom: 3px;
}

.menu_dashboard ::v-deep .v-list-item .v-list-item__title {
  font-size: 0.9rem !important;
  font-weight: 500;
  line-height: 1rem;
}
</style>
